"use client";
/**
 * Banner to display space status alerts sent by API.
 *
 * Alert is embedded in the space entity. Some alerts can be dismissed, when this happens
 * we store the alert's unique ID in localStorage.
 */

import React from "react";
import { useBannerContext } from "@contexts/BannerProvider";
import BannerBar from "./BannerBar";

const Banner: React.FC = () => {
  const { alert, dismissAlert } = useBannerContext();

  if (!alert) return null;

  const { message, style } = alert;

  return (
    <BannerBar
      message={message}
      bannerStyle={style}
      onDismiss={style === "warning" ? dismissAlert : undefined}
    />
  );
};

export default Banner;
